// src/prototype/hooks/useActingAs.ts
// "Acting as" persona for the Execute hub demo: every note, tick and decision is stamped with it.
import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_PERSONA_ID, personaById, type Persona } from '../data/execute/approvalWorkflow';

export const ACTING_AS_KEY = 'dva_demo_acting_as';
const EVT = 'dva_demo_acting_as_change';

function read(): string {
  try { return localStorage.getItem(ACTING_AS_KEY) || DEFAULT_PERSONA_ID; } catch { return DEFAULT_PERSONA_ID; }
}

export function useActingAs(): { persona: Persona; setPersonaId: (id: string) => void } {
  const [id, setId] = useState<string>(() => read());
  useEffect(() => {
    const sync = () => setId(read());
    window.addEventListener(EVT, sync);
    window.addEventListener('ea_demo_reset', sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener('ea_demo_reset', sync); };
  }, []);
  const setPersonaId = useCallback((next: string) => {
    try { localStorage.setItem(ACTING_AS_KEY, next); } catch { /* ignore */ }
    setId(next);
    window.dispatchEvent(new CustomEvent(EVT));
  }, []);
  return { persona: personaById(id), setPersonaId };
}

export default useActingAs;
